import { render, staticRenderFns } from "./ProductTags.vue?vue&type=template&id=45dfcd87&"
import script from "./ProductTags.vue?vue&type=script&lang=ts&"
export * from "./ProductTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports